import type { BulkFallo } from '../types';

/** Traducción legible de error_code del BE para los fallos de acciones bulk. */
const ERROR_CODE_MESSAGES: Record<string, string> = {
  protocolo_no_encontrado: 'El protocolo ya no existe. Puede haber sido eliminado.',
  protocolo_bloqueado: 'El protocolo fue modificado por otro usuario. Intentá nuevamente.',
  informe_final_ya_emitido: 'Este protocolo ya tiene informe final emitido.',
  protocolo_sin_analisis: 'No se puede cerrar un protocolo sin análisis cargados.',
  internal_error: 'Error inesperado. Contactá a soporte si el problema persiste.',
};

/** Severidad descendente: menor número = se muestra primero. Códigos desconocidos van al final. */
const SEVERITY_ORDER: Record<string, number> = {
  internal_error: 0,
  protocolo_bloqueado: 1,
  informe_final_ya_emitido: 2,
  protocolo_sin_analisis: 3,
  protocolo_no_encontrado: 4,
};

/** error_code que no cambian con un reintento (el protocolo ya no existe o ya está cerrado). */
const NOT_RETRYABLE_ERROR_CODES = new Set(['informe_final_ya_emitido', 'protocolo_no_encontrado']);

export function getFalloMessage(fallo: BulkFallo): string {
  return ERROR_CODE_MESSAGES[fallo.error_code] ?? fallo.motivo;
}

export function isReintentable(fallo: BulkFallo): boolean {
  return !NOT_RETRYABLE_ERROR_CODES.has(fallo.error_code);
}

export function sortFallidosPorSeveridad(fallidos: BulkFallo[]): BulkFallo[] {
  return [...fallidos].sort(
    (a, b) => (SEVERITY_ORDER[a.error_code] ?? 5) - (SEVERITY_ORDER[b.error_code] ?? 5),
  );
}
